export default "__VITE_ASSET__2f008d1b__"